export default __webpack_public_path__ + "static/media/remoteOperations.f348f0c9.svg";